import { DrawerProps } from 'antd/lib/drawer';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Drawer } from './drawer';
import { Header } from './header';

const StyledDrawer = styled(Drawer)`
  .ant-drawer-header,
  .ant-drawer-header-no-title {
    position: absolute;
    width: 100%;
    background: transparent;
    border: none;
  }

  .ant-drawer-title {
    display: none;
  }

  .ant-drawer-body {
    padding: 0;
  }
`;

const DrawerBody = styled.div`
  padding: 24px;
`;

export interface OzoneDrawerProps extends Omit<DrawerProps, 'title'> {
  title?: string | ReactNode;
  subTitle?: string | ReactNode;
  showTaskColumn?: boolean;
}

export const OzoneDrawer: FC<OzoneDrawerProps> = ({
  title,
  subTitle,
  children,
  ...rest
}) => (
  <StyledDrawer {...rest} title={null}>
    <Header title={title} subTitle={subTitle} />
    <DrawerBody className="drawer__body">{children}</DrawerBody>
  </StyledDrawer>
);
